import { render, staticRenderFns } from "./HeaderDesign.vue?vue&type=template&id=312972c3&"
import script from "./HeaderDesign.vue?vue&type=script&lang=js&"
export * from "./HeaderDesign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports